import { useMedia } from 'react-use';

const MOBILE_BREAKPOINT = '(max-width: 960px)';
type DEVICE_TYPE_MOBILE = 'mobile';
type DEVICE_TYPE_DESKTOP = 'desktop';

export const useDeviceType = (): {
  deviceType: DEVICE_TYPE_DESKTOP | DEVICE_TYPE_MOBILE;
  isMobile: boolean;
} => {
  const isMobile = useMedia(MOBILE_BREAKPOINT);
  return { isMobile, deviceType: isMobile ? 'mobile' : 'desktop' };
};

export const getDeviceType = (): DEVICE_TYPE_DESKTOP | DEVICE_TYPE_MOBILE => {
  return window.matchMedia?.(MOBILE_BREAKPOINT)?.matches ? 'mobile' : 'desktop';
};
